
import Vue from 'vue'
import PlantAvatar from './PlantAvatar.vue'

export default Vue.extend({
  components: { PlantAvatar },
  props: {
    plant: Object,
  },
  data: () => ({
    readonly: true,
  }),
})
